import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { ConsumerEntity } from '../consumer.entity';

export const STATE_NAME = 'consumerEntity';

export const ConsumerEntityState: GenericEntityStateClass<ConsumerEntity> =
  createEntityState<ConsumerEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ConsumerEntityService extends EntityService<ConsumerEntity> {
  constructor() {
    super();
    this.resourceType = 'consumers';
    this.stateClass = ConsumerEntityState;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ConsumerEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
